export default "__VITE_ASSET__5oitYkly__"